import axios from "axios";

export const downloadFabricMasterReport = async (search_value, color) => {
  try {
    if (!search_value) {
      search_value = "";
    } else if (!color) {
      color = "";
    }

    const config = {
      withCredentials: true,
      headers: {
        withCredentials: true,
      },
    };
    const data = await axios.get(
      `${process.env.REACT_APP_URL}/api/fabric-master/download-fabric-master?search=${search_value}&fabric_color=${color}`,
      config
    );
    return data?.data?.result;
  } catch (error) {
    console.log(error);
    return error?.response?.data?.result;
  }
};
